import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { v4 as guid } from 'uuid';
import { Toast, ToastPayload, ToastType } from './toast.types';
import { PURGE } from 'redux-persist';

const toastSlice = createSlice({
  name: 'toast',
  initialState: {
    toasts: [] as Toast[]
  },
  reducers: {
    onError: (state, action: PayloadAction<ToastPayload>) => {
      const toast: Toast = {
        id: guid(),
        title: action.payload.title,
        description: action.payload.description,
        type: ToastType.Error
      };

      state.toasts = [...state.toasts, toast];
    },
    onSuccess: (state, action: PayloadAction<ToastPayload>) => {
      const toast: Toast = {
        id: guid(),
        title: action.payload.title,
        description: action.payload.description,
        type: ToastType.Success
      };

      state.toasts = [...state.toasts, toast];
    },
    onHideToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
    },
    onHideToastByTitle: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.title !== action.payload
      );
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return {
        toasts: []
      };
    });
  }
});

const { actions, reducer } = toastSlice;

export const { onError, onSuccess, onHideToast, onHideToastByTitle } = actions;

export default reducer;
